import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { CartErrorRoot } from './CartError.style';
import HelpList from './HelpList';

export default function CartError() {
  return (
    <CartErrorRoot>
      <Stack component="header" gap={0.5} marginBlockStart={{ xs: 2, md: 3 }}>
        <Heading component="h1" family="secondary" size="2xl" weight="bold">
          <FormattedMessage id="shopping.component.cartError.title" />
        </Heading>
        <Text component="p" size="sm">
          <FormattedMessage id="shopping.component.cartError.subtitle" />
        </Text>
      </Stack>

      <HelpList />
    </CartErrorRoot>
  );
}
